import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import AddIcon from "@mui/icons-material/Add";
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { parse, format } from 'date-fns';
import Chip from '@mui/material/Chip';
import {
    Popover,
    FormLabel,
    RadioGroup,
    Radio,
    IconButton,
} from "@mui/material";
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';

import api from '../../../../../../services/api';
import MenuRecursosFrota from '../components/menu';
import NavegadorGestao from "../../../../../../components/NavBarGestao";
import AnexadorArquivos from "../../../../../../components/AnexadorArquivos";


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));



export default function CadastrarAtribuicao({ flag, veiculo, closeNovaAtribuicao, closeAtualizarAtribuicao, atribuicaoAtualizar }) {

    function formatarDataBR(dateObj) {
        let dia = String(dateObj.getDate()).padStart(2, '0');
        let mes = String(dateObj.getMonth() + 1).padStart(2, '0');
        let ano = dateObj.getFullYear();
        return `${dia}/${mes}/${ano}`;
    }

    const [idAtribuicaoSalva, setIdAtribuicaoSalva] = useState(0);
    const anexadorRef = useRef();


    const classes = useStyles();
    const history = useHistory();

    const [descricao, setDescricao] = useState(flag === 0 ? "" : atribuicaoAtualizar.descricao);


    const [colaboradores, setColaboradores] = useState([]);
    const [colaboradorSelecionado, setColaboradorSelecionado] = useState(flag === 0 ? null : atribuicaoAtualizar.responsavel);

    const [loading, setLoading] = useState(true);

    const [km, setKm] = useState(flag === 0 ? 0.0 : atribuicaoAtualizar.km);
    const [consumo, setConsumo] = useState(flag === 0 ? 0.0 : atribuicaoAtualizar.consumo);
    const [autonomia, setAutonomia] = useState(flag === 0 ? 0.0 : atribuicaoAtualizar.autonomia);


    //  formatarDataBR(new Date( atribuicaoAtualizar.data_devolucao))

    const [dataRetirada, setDataRetirada] = useState(flag === 0 ? '' : formatarDataBR(new Date(atribuicaoAtualizar.data_retirada)));
    const [horaRetirada, setHoraRetirada] = useState(flag === 0 ? '' : atribuicaoAtualizar.hora_retirada);

    const [dataDevolucao, setDataDevolucao] = useState(flag === 0 ? '' : formatarDataBR(new Date(atribuicaoAtualizar.data_devolucao)));
    const [horaDevolucao, setHoraDevolucao] = useState(flag === 0 ? '' : atribuicaoAtualizar.hora_devolucao);


    const [odometroInicio, setOdometroInicio] = useState(flag === 0 ? 0.0 : atribuicaoAtualizar.odometro_inicio);
    const [odometroFim, setOdometroFim] = useState(flag === 0 ? 0.0 : atribuicaoAtualizar.odometro_fim);

    const [litrosInicio, setLitrosInicio] = useState(flag === 0 ? 0.0 : atribuicaoAtualizar.litros_inicio);
    const [litrosFim, setLitrosFim] = useState(flag === 0 ? 0.0 : atribuicaoAtualizar.litros_fim);


    async function listarInformacoes() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }



            await api.get("v1/protected/colaboradores/listartodos", {
                headers: headers
            }).then(function (response) {
                setColaboradores(response.data)

                setLoading(false);



            });


        } catch (_err) {
            // avisar('Houve um problema com o login, verifique suas credenciais! ' + cpf + " " + senha );
            console.log("Erro ao listar os Solicitantes: " + _err)

        }

    }


    useEffect(() => {
        listarInformacoes();

    }, []);



    function returnDescricaoColaborador(colaborador) {


        var texto = "Colaborador_ID: " + colaborador.id_colaborador +
            "\nCPF: " + colaborador.cpf +
            "\nNome: " + colaborador.nome + " " + colaborador.sobrenome + "\n ";
        return texto;
    }






    async function salvar() {


        try {

            if (!colaboradorSelecionado) {
                alert("Selecione o Responsável");
                return;
            }



            console.log("cadastrar chamado");
            const cadastro = {
                veiculo_id: veiculo.id_veiculo,
                responsavel: { id_colaborador: colaboradorSelecionado.id_colaborador },
                usuario_criador: { id_usuario: Cookies.get('id_usuario') },
                odometro_inicio: parseFloat(odometroInicio),
                odometro_fim: parseFloat(odometroFim),
                litros_inicio: parseFloat(litrosInicio),
                litros_fim: parseFloat(litrosFim),

            };

            if (dataRetirada && parse(dataRetirada, 'dd/MM/yyyy', new Date()) instanceof Date) {

                cadastro.data_retirada = format(parse(dataRetirada, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
            } else {
                alert("Informe uma data de retirada válida!");
                return;
            }

            if (horaRetirada && parse(horaRetirada, 'HH:mm', new Date()) instanceof Date) {

                cadastro.hora_retirada = format(parse(horaRetirada, 'HH:mm', new Date()), 'HH:mm');
            } else {
                alert("Informe uma hora de retirada válida!");
                return;
            }



            if (dataDevolucao) {
                if (parse(dataDevolucao, 'dd/MM/yyyy', new Date()) instanceof Date) {

                    cadastro.data_devolucao = format(parse(dataDevolucao, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
                } else {
                    alert("Data da devolução está incorreta, revise!");
                    return;
                }
            }

            if (horaRetirada) {
                if (parse(horaRetirada, 'HH:mm', new Date()) instanceof Date) {

                    cadastro.hora_retirada = format(parse(horaRetirada, 'HH:mm', new Date()), 'HH:mm');
                } else {
                    alert("Hora da devolução está incorreta, revise!");
                    return;
                }
            }



            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            };

            try {
                const response = await api.post(
                    '/v1/protected/veiculos/atribuicoes/cadastrar',
                    cadastro,
                    { headers }
                );

                const cadastro_salvo = response.data;
                if (cadastro_salvo) {
                    setIdAtribuicaoSalva(cadastro_salvo.id_atribuicao);
                    alert("Atribuição cadastrada com sucesso!");
                } else {
                    alert("Erro de conexão, tente novamente mais tarde");
                }
            } catch (err) {
                if (err.response && err.response.status === 409) {
                    alert(err.response.data); // "Já existe uma atribuição em andamento..."
                } else {
                    alert("Erro de conexão, tente novamente mais tarde");
                }
            }

        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde " + _err);

        }



    }





    useEffect(() => {
        if (odometroFim) {
            setKm(odometroFim - odometroInicio);

        }
    }, [odometroFim]);




    useEffect(() => {
        if (idAtribuicaoSalva > 0 && anexadorRef.current) {
            anexadorRef.current.salvarArquivos();
        }
    }, [idAtribuicaoSalva]);


    async function atualizar() {


        try {




            console.log("cadastrar chamado");
            const cadastro = {
                odometro_fim: parseFloat(odometroFim),
                litros_fim: parseFloat(litrosFim),

            };




            if (dataDevolucao) {
                if (parse(dataDevolucao, 'dd/MM/yyyy', new Date()) instanceof Date) {

                    cadastro.data_devolucao = format(parse(dataDevolucao, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd');
                } else {
                    alert("Data da devolução está incorreta, revise!");
                    return;
                }
            }

            if (horaDevolucao) {
                if (parse(horaDevolucao, 'HH:mm', new Date()) instanceof Date) {

                    cadastro.hora_devolucao = format(parse(horaDevolucao, 'HH:mm', new Date()), 'HH:mm');
                } else {
                    alert("Hora da devolução está incorreta, revise!");
                    return;
                }
            }



            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const response = await api.post('/v1/protected/veiculos/atribuicoes/atualizar/' + atribuicaoAtualizar.id_atribuicao, cadastro,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                closeAtualizarAtribuicao();
                alert("Atribuição Atualizar!");

            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde " + _err);

        }



    }





    return (
        <>
            {!loading &&
                <Grid container spacing={2}   >
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        item xs={10}
                    >
                        {flag === 0 && (
                            <Button style={{ margin: 5 }}
                                variant="contained"
                                color="primary"
                                onClick={salvar}
                            > Salvar  </Button>
                        )}

                        {flag === 1 && (
                            <Button style={{ margin: 5 }}
                                variant="contained"
                                color="primary"
                                onClick={atualizar}
                            > Atualizar  </Button>
                        )}
                    </Grid>

                    <Grid item xs={12}
                        container
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                    >






                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            align="center"
                            item xs={7}
                            style={{ marginTop: 5 }}
                        >
                            <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                align="center"
                                item xs={12} >
                                <Autocomplete
                                    id="select-colaborador"
                                    options={colaboradores}
                                    disableCloseOnSelect
                                    getOptionLabel={(colaborador) => returnDescricaoColaborador(colaborador)}
                                    value={colaboradorSelecionado}
                                    onChange={(e, v) => setColaboradorSelecionado(v)}
                                    renderInput={(params) => (
                                        <TextField {...params} label=" Responsável "

                                            multiline
                                            minRows={3} />
                                    )}
                                />
                            </Grid>
                        </Grid>




                        <Grid item xs={12}
                            container
                            alignItems="center"
                            justifyContent="center"

                        >

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="dataRetirada"
                                    label="Data da Retirada"
                                    id="dataRetirada"
                                    value={dataRetirada}
                                    onChange={(e) => setDataRetirada(e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="horaRetirada"
                                    label="Hora da Retirada"
                                    id="horaRetirada"
                                    value={horaRetirada}
                                    onChange={(e) => setHoraRetirada(e.target.value)}
                                    fullWidth
                                />
                            </Grid>


                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="odometroInicio"
                                    label="Odómetro Inicial"
                                    id="odometroInicio"
                                    value={odometroInicio}
                                    onChange={(e) => setOdometroInicio(e.target.value)}
                                    fullWidth
                                />
                            </Grid>


                            <Grid container spacing={2} alignItems="center">

                                {/* CAMPO NUMÉRICO */}
                                <Grid item xs={3} style={{ padding: 5 }}>
                                    <TextField
                                        variant="standard"
                                        label="Combustível Inicial (0 a 8)"
                                        type="number"
                                        inputProps={{
                                            min: 0,
                                            max: 8,
                                            step: 0.1
                                        }}
                                        value={litrosInicio}
                                        onChange={(e) => {
                                            let v = Number(e.target.value);

                                            if (v < 0) v = 0;
                                            if (v > 8) v = 8;

                                            setLitrosInicio(v);
                                        }}
                                        fullWidth
                                    />
                                </Grid>

                                {/* EQUAÇÃO + RESULTADO */}
                                <Grid item xs={9}>
                                    <Typography variant="body2" color="textSecondary">
                                        {veiculo.capacidade_combustivel} × {litrosInicio}/8
                                    </Typography>

                                    <Typography variant="h6">
                                        {(
                                            veiculo.capacidade_combustivel * (litrosInicio / 8)
                                        ).toFixed(2)} litros no tanque
                                    </Typography>
                                </Grid>

                            </Grid>


                        </Grid>



                        <Grid item xs={12}
                            container
                            alignItems="center"
                            justifyContent="center"

                        >

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="dataDevolucao"
                                    label="Data da Devolução"
                                    id="dataDevolucao"
                                    value={dataDevolucao}
                                    onChange={(e) => setDataDevolucao(e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="horaDevolucao"
                                    label="Hora da Devolução"
                                    id="horaDevolucao"
                                    value={horaDevolucao}
                                    onChange={(e) => setHoraDevolucao(e.target.value)}
                                    fullWidth
                                />
                            </Grid>


                            <Grid item xs={3}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="odometroFim"
                                    label="Odómetro Final"
                                    id="odometroFim"
                                    value={odometroFim}
                                    onChange={(e) => setOdometroFim(e.target.value)}
                                    fullWidth
                                />
                            </Grid>




                            <Grid container spacing={2} alignItems="center">

                                {/* CAMPO NUMÉRICO */}
                                <Grid item xs={3} style={{ padding: 5 }}>
                                    <TextField
                                        variant="standard"
                                        label="Combustível Final (0 a 8)"
                                        type="number"
                                        inputProps={{
                                            min: 0,
                                            max: 8,
                                            step: 0.1
                                        }}
                                        value={litrosFim}
                                        onChange={(e) => {
                                            let v = Number(e.target.value);

                                            if (v < 0) v = 0;
                                            if (v > 8) v = 8;

                                            setLitrosFim(v);
                                        }}
                                        fullWidth
                                    />
                                </Grid>

                                {/* EQUAÇÃO + RESULTADO */}
                                <Grid item xs={9}>
                                    <Typography variant="body2" color="textSecondary">
                                        {veiculo.capacidade_combustivel} × {litrosFim}/8
                                    </Typography>

                                    <Typography variant="h6">
                                        {(
                                            veiculo.capacidade_combustivel * (litrosFim / 8)
                                        ).toFixed(2)} litros no tanque
                                    </Typography>
                                </Grid>

                            </Grid>


                        </Grid>


                        <Grid item xs={12}
                            container
                            alignItems="center"
                            justifyContent="center"

                        >

                            <Grid item xs={4}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="km"
                                    label="Quilometragem"
                                    id="km"
                                    value={km}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={4}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="consumo"
                                    label="Consumo"
                                    id="consumo"
                                    value={consumo}
                                    fullWidth
                                />
                            </Grid>
                            {/*
                             <Grid item xs={4}
                                style={{ padding: 5 }}
                            >
                                <TextField
                                    variant="standard"
                                    name="autonomia"
                                    label="Autonomia"
                                    id="autonomia"
                                    value={autonomia}
                                    fullWidth
                                />
                            </Grid>
 */}
                        </Grid>


                        <Grid item xs={12}>
                            <TextField
                                variant="standard"
                                name="descricao"
                                label="Descrição"
                                id="descricao"
                                value={descricao}
                                onChange={(e) => setDescricao(e.target.value)}
                                fullWidth
                                multiline
                                minRows={3}
                            />
                        </Grid>







                    </Grid>



                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        align="center"
                        item xs={12}
                        style={{ marginTop: 5 }}
                    >
                        <AnexadorArquivos
                            ref={anexadorRef}
                            flag={flag}
                            isAtribuicao={true}
                            objeto={flag === 1 ? atribuicaoAtualizar : null}
                            id={flag === 1 ? atribuicaoAtualizar.id_atribuicao : idAtribuicaoSalva}
                            close={closeNovaAtribuicao}

                        />
                    </Grid>



                </Grid>
            }




        </>
    );
}


